import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  basicDetails: {
    name: '',
    vasProvider: '',
    packageName: '',
    packageCode: '',
    providerType: 'API',
    periodInMonths: '',
    vasAggregateId: null
  }
};

export const VASProviderPackageSlice = createSlice({
  name: 'vasProviderPackage',
  initialState,
  reducers: {
    setBasicDetails: (state, action) => {
      state.basicDetails = action.payload;
    },
    setField: (state, action) => {
      const { field, value } = action.payload;
      state.basicDetails[field] = value;
    },
    reset: () => initialState,
  },
});

export const {
  setBasicDetails,
  setField,
  reset,
} = VASProviderPackageSlice.actions;

export default VASProviderPackageSlice.reducer;
